export const API_PATH_ApiAlertMgtmAlertHandlingUnresolve = '/services/alerts-mgtm/apiAlertMgtmAlertHandlingUnresolve';
